(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
/* Automatic logo carousel without visible controls. */
if (!customElements.get('dg-announcement-logo-slider')) {
  customElements.define('dg-announcement-logo-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      if (!this.querySelector('.dg-logo-track')) {
        this.initFrame = requestAnimationFrame(() => this.connectedCallback());
        return;
      }

      this.controller = new AbortController();
      this.viewport = this.querySelector('.dg-logo-scroll');
      this.track = this.querySelector('.dg-logo-track');
      this.logos = Array.from(this.track.querySelectorAll('.dg-announcement-logo'));
      this.pages = [];
      this.index = 0;
      this.count = 0;
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Math.max(3000, Math.min(15000, Number(this.dataset.interval) || 5000));
      this.hidden = this.logos.length === 0;

      const listen = (target, type, fn, options = {}) => target.addEventListener(type, fn, {
        ...options, signal: this.controller.signal
      });

      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.mobile, 'change', () => this.buildPages());
      listen(this.reduced, 'change', () => this.goTo(this.index, false));

      const section = this.closest('.shopify-section');
      if (section) {
        listen(section, 'shopify:block:select', event => {
          const logo = event.target.closest('.dg-announcement-logo');
          const number = this.logos.indexOf(logo);
          if (number >= 0 && this.count) this.goTo(Math.floor(number / this.count), false);
        });
      }

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (width === this.lastWidth) return;
          this.lastWidth = width;
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.goTo(this.index, false));
        });
        this.resizeObserver.observe(this.viewport);
      } else {
        listen(window, 'resize', () => this.goTo(this.index, false), { passive: true });
      }

      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.isVisible = entries[0].isIntersecting;
          this.schedule();
        });
        this.intersectionObserver.observe(this);
      } else {
        this.isVisible = true;
      }

      this.buildPages();
    }

    buildPages() {
      this.clearTimer();
      const anchor = this.index * this.count;
      this.count = this.mobile.matches
        ? Math.max(1, Math.min(3, Number(this.dataset.mobileCount) || 2))
        : Math.max(2, Math.min(8, Number(this.dataset.desktopCount) || 5));

      const holder = document.createDocumentFragment();
      this.logos.forEach(logo => holder.appendChild(logo));
      this.track.querySelectorAll('.dg-logo-page').forEach(page => page.remove());
      this.pages = [];

      const total = Math.ceil(this.logos.length / this.count);
      for (let start = 0; start < this.logos.length; start += this.count) {
        const page = document.createElement('div');
        page.className = 'dg-logo-page';
        page.style.setProperty('--dg-logo-slots', String(Math.min(this.count, this.logos.length)));
        page.setAttribute('role', 'group');
        page.setAttribute('aria-label', `Logo-Gruppe ${this.pages.length + 1} von ${total}`);
        this.logos.slice(start, start + this.count).forEach(logo => page.appendChild(logo));
        this.pages.push(page);
        this.track.appendChild(page);
      }

      this.classList.add('is-ready');
      this.goTo(Math.min(Math.floor(anchor / this.count), Math.max(total - 1, 0)), false);

      // Prevent a flash of the ungrouped logo layout on first paint.
      // visibility:hidden still keeps the correct bar height and viewport width,
      // so we can calculate the carousel before revealing it.
      requestAnimationFrame(() => {
        if (this.isConnected) this.style.visibility = 'visible';
      });
    }

    goTo(number, animate = true) {
      if (!this.controller || !this.pages.length) return;
      this.clearTimer();
      const next = ((number % this.pages.length) + this.pages.length) % this.pages.length;
      const wrapping = Math.abs(next - this.index) > 1;
      this.index = next;
      this.syncAccessibility();
      const direction = getComputedStyle(this.viewport).direction === 'rtl' ? -1 : 1;

      this.viewport.scrollTo({
        left: direction * next * this.viewport.clientWidth,
        behavior: animate && !wrapping && !this.reduced.matches ? 'smooth' : 'auto'
      });
      this.schedule();
    }

    syncAccessibility() {
      this.pages.forEach((page, index) => {
        const active = index === this.index;
        page.inert = !active;
        if (active) page.removeAttribute('aria-hidden');
        else page.setAttribute('aria-hidden', 'true');
        page.querySelectorAll('a[href]').forEach(link => {
          if (active) link.removeAttribute('tabindex');
          else link.setAttribute('tabindex', '-1');
        });
      });
    }

    clearTimer() {
      clearTimeout(this.timer);
      this.timer = null;
    }

    schedule() {
      this.clearTimer();
      if (!this.controller || !this.isConnected || !this.autoplay || document.hidden ||
          this.isVisible === false || this.pages.length < 2) return;
      this.timer = setTimeout(() => this.goTo(this.index + 1), this.interval);
    }

    disconnectedCallback() {
      this.clearTimer();
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.resizeFrame);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
